<template>
  <div dir="rtl">
    <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}">
      <v-img :src="$replaceHttps(item.FileUrl)" alt="عکس محصول" aspect-ratio="1" class="rounded-lg bg-white" contain>
        <div class="d-flex flex-column" style="height: 100%">
          <div class="mt-1 mr-2"><span v-if="item.tip.Discount  !== 0" class="product-card-discount rounded-circle">{{
              item.tip.Discount
            }} %</span>
          </div>
          <div class="mt-auto mb-1 mr-2 "><span class="product-card-bookmark rounded-circle pointer"
                                                @click.stop.prevent="setBookMark"><i
              :class="productBookmarkActive ? 'red--text fa-solid fa-bookmark' :'fa-light fa-bookmark'"
              class=" fa-lg white--text"></i></span>
          </div>
        </div>
      </v-img>
    </router-link>
    <div class="row  no-gutters pt-1">
      <div class="col-9 text-truncate third-text">
        {{ item.Name }}
      </div>
      <div class="col-3">
        <i class="fa-solid fa-star yellow--text"></i> {{ $roundNum(item.avgVote) }}/10
      </div>
    </div>
    <div class="row  no-gutters pt-1">
      <div class="col-5 text-center pt-1">
        <div><span class="third-text"> {{ $computingPriceOffer(item.tip.Price, item.tip.Discount) }}</span>
          <span>تومان</span></div>
      </div>
      <div class="col-4 text-left">
        <div v-if="item.tip.Discount !==0" class="font12px pt-2 text-decoration-line-through grey--text ">
          {{ $numberWithCommas(item.tip.Price) }}
        </div>
      </div>
      <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" class="col-3 text-left">
        <v-avatar size="37">
          <img

              :src="$replaceHttps(item.ProductCategorFileUrl)"
              alt="لوگو برند">
        </v-avatar>
      </router-link>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: ['item'],
  data: () => ({
    productBookmarkActive: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: ''

  }),
  mounted() {
    this.checkUserSaveProduct()
  },
  methods: {
    setBookMark() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.item.VendorProductID);
      urlencoded.append("TypeBookMark", "1");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.productBookmarkActive = !this.productBookmarkActive
              this.$store.commit('addOrRemoveBookmarkItemToList', this.item.VendorProductID)
            }
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    checkUserSaveProduct() {
      this.userSaved = this.$store.getters.getUserBookmarks
      let saves = this.userSaved
      let id = this.item.VendorProductID
      if (saves.find(x => x.RelationID === id) !== undefined) {
        this.productBookmarkActive = true
      }
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    }
  }
}
</script>

<style scoped>

</style>
